module.exports = __webpack_public_path__ + "static/media/bnf.91aaec90.jpg";